<template>
    <div class="webcastsRisk"></div>
</template>

<script>
export default {
    name: 'webcastsRisk',
    props:{
        pondsid:Number,

    },
    data() {
        return {
            myChart: null,
            xData:[],
            yData:[]
        }
    },
    methods: {

        getData() {
            this.request.get("/api/Echart/getfeed", {
                params: {
                    pondsid: this.pondsid,
                    number:10
                }
            }).then(res => {
                if (res.code == 200) {
                    this.xData = res.data.map(item => {
                        const timeParts = item.time.split("T");
                        const datePart = timeParts[0]; // 获取日期部分，即 "2024-03-30"
                        const timePart = timeParts[1]; // 获取时间部分，即 "10:03:47"

                        // 从日期部分提取月和日
                        const month = datePart.substring(5, 7); // "03"
                        const day = datePart.substring(8, 10); // "30"

                        // 从时间部分提取时和分
                        const hour = timePart.substring(0, 2); // "10"
                        const minute = timePart.substring(3, 5); // "03"

                        // 拼接成 "月 日 时 分" 的格式
                        return `${month}-${day} ${hour}:${minute}`;
                    })
                    this.yData = res.data.map(item => {
                        return item.amount
                    })
                    this.setWebcasts()
                }
            })
        },
        // 图像绘制
        setWebcasts() {
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#6dd0e3',
                        fontSize: 10,
                    },
                },
                grid: {
                    top: '12%',
                    bottom: '12%',
                    left: '8%',
                    right: '5%',
                },
                legend: {
                    right: '5%',
                    top: '10%',
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 5],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {
                        color: '#122C49',
                        inside: true
                    },
                    z: 2,
                    data: this.xData
                },
                yAxis:
                    {
                        type: 'value',
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 10
                        },
                        splitLine: {
                            show: false,
                        },
                        name: '(斤)',
                        nameGap: 0,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                    },

                series: [{
                    name: '饲料数',
                    type: 'line',
                    symbol: 'none',
                    data: this.yData,
                    lineStyle: {
                        width: 1,
                        color:{
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#FF3E96' // 0% 处的颜色
                            },
                                {
                                    offset: 0.5, color: '#FF3E96' // 40% 处的颜色
                                }, {
                                    offset: 1, color: '#694d9f' // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        } //背景渐变色
                    },
                    itemStyle: {
                        color: '#8552a1'
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#A41B68' // 0% 处的颜色
                            },
                                {
                                    offset: 0.5, color: 'rgba(243,113,92, 0.5)' // 40% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(243,113,92  , 0)' // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        }, //背景渐变色
                        origin: 'start'
                    }
                },
                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
        },
    },
    mounted() {
        this.getData()
    },
    watch: {
        pondsid() {
            this.getData()
        }
    }
}
</script>

<style lang="less" scoped>
.webcastsRisk {
    margin-top: 5%;
    height: 45%;
}
</style>
